import { injectable } from 'tsyringe'
import { DropBox, DropBoxes } from '@/domain/entities/DropBox'
import { DropBoxApiRepository } from '@/app/infrastructures/repositories/api/DropBoxApiRepository'
import {
  CreateDropBoxRequestInterface,
  UpdateDropBoxRequestInterface,
} from '@/data/payload/contracts/DropBoxRequest'

@injectable()
export class DropBoxPresenter {
  private repository: DropBoxApiRepository

  constructor(repository: DropBoxApiRepository) {
    this.repository = repository
  }

  public getAll(
    params: Map<string, string | number | boolean>
  ): Promise<DropBoxes> {
    return this.repository.getAll(params)
  }

  public getMonitoring(
    params: Map<string, string | number | boolean>
  ): Promise<DropBoxes> {
    return this.repository.getMonitoring(params)
  }

  public get(externalId: string): Promise<DropBox | null> {
    return this.repository.get(externalId)
  }

  public create(payload: CreateDropBoxRequestInterface): Promise<boolean> {
    return this.repository.create(payload)
  }

  public update(payload: UpdateDropBoxRequestInterface): Promise<boolean> {
    return this.repository.update(payload)
  }

  public delete(externalId: string): Promise<boolean> {
    return this.repository.delete(externalId)
  }
}
